import React from 'react';
import { Route } from 'react-router-dom';

import Routes from '../../constants/Routes';

import QuoteListPage from './pages/list';
import NewQuoteInfo from './pages/add';
import NewQuotePlans from './pages/plans';
import PaymentPage from './pages/payment';
import ViewEnquirity from './pages/edit_v2';

export default function QuotationRoutes() {
  return (
    <>
      <Route exact path={Routes.QUOTATIONS} component={QuoteListPage} />
      <Route path={Routes.NEWQUOTATIONINFO} component={ViewEnquirity} />
      <Route path={Routes.NEWQUOTATIONPLANS} component={NewQuotePlans} />
      <Route path={Routes.PAYMENTS} component={PaymentPage} />
      {/* <Route path={Routes.VIEWENQUIRITY} component={ViewEnquirity} /> */}
    </>
  );
}
